/**
 * 印刷用データテーブルの共通クラス（発送予定印刷ビューを基準）。
 * Tailwind の内容検出のため、クラス名は文字列リテラルとして完結させる。
 */

export const PRINT_TABLE = 'w-full border-collapse table-fixed print:text-xs';

export const PRINT_THEAD = 'bg-slate-100 border-b border-slate-600';

/** 検索条件行（印刷時のみ thead 内） */
export const PRINT_SEARCH_ROW_TR = 'hidden print:table-row';
export const PRINT_SEARCH_ROW_TH = 'px-1 py-0.5 text-left text-[11px] font-normal text-slate-800';

export const PRINT_TH_LEFT =
  'px-1 py-1 text-left text-[11px] font-semibold text-slate-900 whitespace-normal break-words border-b border-slate-600';
export const PRINT_TH_RIGHT =
  'px-1 py-1 text-right text-[11px] font-semibold text-slate-900 whitespace-normal break-words border-b border-slate-600';

export const PRINT_TR_BODY = 'border-b border-slate-500 break-inside-avoid';

/** 2行ブロック（品名/寸法・納入先 等） */
export const PRINT_TD_COMPOSITE =
  'px-1 py-0.5 align-middle text-[11px] text-slate-900 whitespace-normal break-words text-left';

export const PRINT_TD_LEFT = 'px-1 py-0.5 text-left text-[11px] text-slate-900';

export const PRINT_TD_NUM = 'px-1 py-0.5 text-right text-[11px] text-slate-900 tabular-nums';

export const PRINT_TD_DEFAULT_LEFT =
  'px-1 py-0.5 text-[11px] text-slate-900 whitespace-normal break-words text-left';

export const PRINT_TD_DEFAULT_NUM =
  'px-1 py-0.5 text-[11px] text-slate-900 whitespace-normal break-words text-right tabular-nums';

/** 印刷時のみのタイトル行（1ページ目先頭） */
export const PRINT_PAGE_TITLE_ROW = 'hidden print:flex items-center gap-3 px-4 pt-4 pb-1';
export const PRINT_PAGE_TITLE_H1 = 'text-base font-semibold text-slate-900';
export const PRINT_PAGE_TITLE_COUNT = 'text-[11px] text-slate-700';

/** スクロール領域（親の print-view-root と組み合わせ） */
export const PRINT_SCROLL_CONTAINER = 'flex-1 overflow-auto print-scroll-container';

/** 入荷予定 印刷テーブル列幅（8列・合計100%） */
export const INBOUND_PRINT_COL_WIDTHS = [
  '7%', // 予定納期
  '7%', // 発注No
  '6%', // 発注日
  '11%', // 仕入先
  '6%', // 製品コード
  '47%', // 製品名/寸法
  '8%', // 数量
  '8%', // 単位
];

/**
 * 仕入先共有 印刷テーブルで複数行ブロックを持つ列。
 * PRINT_TD_COMPOSITE を当てて折り返しを有効にする（社内参照・仕入先編集の両ビュー共通）。
 */
export const SUPPLIER_SHARE_PRINT_COMPOSITE_KEYS = [
  'shukka_hacchu_date',
  'juchu_hacchu_no',
  'shain_pair',
  'request_pair',
  'customer_nonyusaki',
  'product_name_size',
  'ship_arrival',
  'juchu_direct_address',
];

/** 仕入先共有 印刷テーブル列幅（printColumns の key 順・合計100%） */
export const SUPPLIER_SHARE_PRINT_COL_WIDTHS = {
  shukka_hacchu_date: '5%',
  juchu_hacchu_no: '6%',
  shain_pair: '5%',
  request_pair: '5%',
  customer_nonyusaki: '7%',
  genba_name: '4%',
  supplier_response_due_date: '4%',
  ship_arrival: '5%',
  total_weight: '3%',
  product_disp: '4%',
  product_name_size: '8%',
  hacchu_amount: '4%',
  product_weight: '3%',
  supplier_name: '5%',
  product_spec: '4%',
  juchu_direct_name: '5%',
  juchu_direct_address: '11%',
  juchu_biko: '5%',
  supplier_share_memo: '7%',
};
